import React, {Component} from 'react';
import EndScoreScreen from './EndingScreen.jsx';

export default class GameEndHandler extends Component {
    constructor(props) {
        super(props);
    }
    render(){
        let viewComponent = "";
        let viewName = this.props.information.view.split('.').slice(-1)[0];
        switch(viewName){
            case("score"):
                viewComponent = (
                    <EndScoreScreen
                        information={this.props.information}
                        exitGame={this.props.exitGame}
                    />
                );
                break;
        }
            return (
                <div>
                    {viewComponent}
                </div>
            );
    }
}